import {Component} from 'ng-metadata/core';



@Component({
selector: 'prm-spinner',
templateUrl: 'components/spinner/spinner.html',
})


export class PrmSpinner{

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/spinner/spinner.directive.ts